import {CONSTANTS} from '@/constants'
import { functions } from '@/functions';
import miniToastr from 'mini-toastr'

export const functions_voucher_print = {
    data: function () {
        return {
        };
    },
    mixins: [functions],
    components: { },
    computed: { },
    methods: {

        printInvoice: function(voucher, faximile=false) {
            let data = {faximile:faximile};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/invoice') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Счет', response.report_url);
                }, this.httpError );
        },
        printContract: function(voucher, faximile=false) {
            let data = {faximile:faximile};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/contract') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Договор', response.report_url);
                }, this.httpError);
        },
        printVoucher: function(voucher, faximile=false) {
            let data = {faximile:faximile};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/voucher') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Путевка', response.report_url);
                }, this.httpError);
        },
        printVst: function(voucher) {
            let data = {};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/banner') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Баннер', response.report_url);
                }, this.httpError);
        },
        printCalc: function(voucher) {
            this.httpPrepare();
            this.$http.post(this.apiurl('report/create'), {voucher_id:this.voucher.id, report_type:'T_VOUCHER_CALCULATION'}).then(function (response) {
                response = this.httpSuccess(response);
                this.openReportWindow(response.report_text, 'Калькуляция', response.report_url);
            }, this.httpError);
        },

        printHotelBookRequest: function(voucher) {
            let data = {};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/book-request') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Заявка на бронирование', response.report_url);
                }, this.httpError);
        },

        printHotelChangeRequest: function(voucher) {
            let data = {};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/book-change') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Запрос на изменение', response.report_url);
                }, this.httpError);
        },

        printHotelCancelRequest: function(voucher) {
            let data = {};

            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/book-cancel') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Запрос на отмену', response.report_url);
                }, this.httpError);
        },

        printCheckinList: function(voucher) {
            let data = {};

            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/checkin-list') , data).then(
                function (response) {
                    this.httpSuccess(response);
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Лист заезжающего', response.report_url);
                }, this.httpError);
        },

        sendDocuments: function(voucher) {
            let data = {
                'send_invoice':true,
                'send_voucher':true,
                'send_contract':true,
                'faximile':true,
            };

            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/send-documents') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    miniToastr["success"]('Документы высланы на электронную почту', null, 15000);
                }, this.httpError);
        },

        createDocuments: function(voucher, faximile) {
            let data = {
                'create_invoice':true,
                'create_voucher':true,
                'create_contract':true,
                'faximile':faximile,
            };

            this.httpPrepare();
            this.$http.put(this.apiurl('report/voucher/'+voucher.id+'/create-documents') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                }, this.httpError);
        },

        printBookingBill: function(booking, faximile=false) {
            let data = {faximile:faximile};
            this.httpPrepare();
            this.$http.put(this.apiurl('report/booking/'+booking.id+'/bill') , data).then(
                function (response) {
                    response = this.httpSuccess(response);
                    this.openReportWindow(response.report_text, 'Счет от системы', response.report_url);
                }, this.httpError);
        },
    }
}
